const actions = {
  
  TRANSACTIONS_READ_BEGIN: 'TRANSACTIONS_READ_BEGIN',
  TRANSACTIONS_READ_SUCCESS: 'TRANSACTIONS_READ_SUCCESS',
  TRANSACTIONS_READ_ERR: 'TRANSACTIONS_READ_ERR',

  TRANSACTION_READ_BEGIN: 'TRANSACTION_READ_BEGIN',
  TRANSACTION_READ_SUCCESS: 'TRANSACTION_READ_SUCCESS',
  TRANSACTION_READ_ERR: 'TRANSACTION_READ_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.TRANSACTIONS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.TRANSACTIONS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.TRANSACTIONS_READ_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.TRANSACTION_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.TRANSACTION_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.TRANSACTION_READ_ERR,
      err,
    };
  },

};

export default actions;
